import { h, Component, Fragment } from "preact";
import { route } from "preact-router";
import { Trans } from "@lingui/react/macro";
import { msg } from "@lingui/core/macro";

import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'

import PFeed from "../../../services/prematch-feed";
import LFeed from "../../../services/live-feed";
import Page from "../../../services/page-data-feed";
import User from "../../../services/user";

import { PaddedContainer } from "../mobile-templates/general";

import MenuTimeFilter from "../mobile-components/menu-time-filter"
import { SearchComponent, WrappedPrematchTournamentPage, TournamentCard } from "./prematch";
import { Tournament } from "./live";

import { WidgetEventsCarouselContent } from "../desktop-components/prematch-events-widget";
import SchedulesTimeFilter from "../utils/schedules-time-filter"
import FullSite from "./full-site";

import PrematchLiveEvents from "../desktop-components/prematch-live-events";
import { PrematchLastminuteContent } from "../desktop-components/prematch-last-minute";
import PrematchCarousel from "../desktop-components/prematch-carousel";

import * as P from "../mobile-templates/sports";
import * as T from "../mobile-templates/tournament";
import * as D from "../desktop-templates/prematch-tournament.jsx";
import * as I from "../utils/icons";

import { TodayWidget } from '../mobile-components/today-widget.jsx';
import { MarketingEvents } from "../../../utils/gtm-module";

export default class MobilePageHome extends Component {
	componentWillMount() {
		window.dispatchEvent(new Event(MarketingEvents.HOMEPAGE))
		PFeed.getMenu(() => {
			this.setState({});
		})
	}
	render() {
		const sortedSportsList = PFeed.menu ? Object.values(PFeed.menu).sort((a, b) => a.order - b.order) : null;
		return <FullSite class="bg-slate-300 text-slate-950 dark:bg-transparent dark:text-inherit">
			<P.SportsHolder>
				<P.SportLikeButton onClick={e => window.location.href += '#betslip'}>
					<P.SportIconBox><I.TicketIcon class="h-6 -rotate-45" /></P.SportIconBox>
					<P.SportName>Check Bet</P.SportName>
				</P.SportLikeButton>
				{User.isLogged() && <P.SportLikeButton onClick={e => route('/cashout')}>
					<P.SportIconBox><I.UserIcon class="h-full text-kobaaccent-500" /></P.SportIconBox>
					<P.SportName>My Bets</P.SportName>
				</P.SportLikeButton>}
				<P.SportLikeButton onClick={e => route('/live')}>
					<P.SportIconBox><I.LiveIcon class="h-full" /></P.SportIconBox>
					<P.SportName>Live</P.SportName>
				</P.SportLikeButton>
				{sortedSportsList && sortedSportsList
					.filter(s => SchedulesTimeFilter.isScheduleAllowed(s))
					.map(sport => {
						return <P.SportButton sport={sport} onClick={e => route('/prematch/' + sport.id.split('/')[2])} />
					})
				}
			</P.SportsHolder>
			<div class="aspect-1865/380 w-full">
				<PrematchCarousel />
			</div>
			<PaddedContainer>
				<WidgetEventsCarouselContent />
			</PaddedContainer>
			<P.HeaderContainer>
				<MenuTimeFilter />
				<SearchComponent />
			</P.HeaderContainer>

			<WithPrematch><MobileTopWidget /></WithPrematch>
			<WithPrematch><MobileLiveEvents /></WithPrematch>
		</FullSite>
	}
}

export class MobileTopWidget extends Component {
	render() {
		return <div>
			<D.CardHeaderRow>
				<D.ThreeDots />
				<D.TournamentSportName><Trans>Today</Trans> | {"የዛሬ ጨዋታዎች"}</D.TournamentSportName>
			</D.CardHeaderRow>
			<TodayWidget sport={PFeed.menu['/sport/1']} />
		</div>
	}
}

export class MobileTopLeagues extends Component {
	state = {
		topLeagues: [],
		currentTournamentId: null,
		tournamentCard: null
	};

	compareNonZero(/**@type {() => number}*/ accessor) {
		return (a, b) => {
			const valueA = accessor(a) || 1e6;
			const valueB = accessor(b) || 1e6;
			return valueA - valueB;
		}
	}

	componentWillMount() {
		PFeed.getMenu((type, menu) => {
			if (!!PFeed.mainTournaments) {
				const topLeagues = PFeed.mainTournaments.map(tId => PFeed.NStorage.get(tId)).filter(tournament => !!tournament);
				const sortedTopleagues = topLeagues.map(tournament => PFeed.getWithParents(tournament.id))
					.sort(this.compareNonZero(row => row.sport.order))
					.sort(this.compareNonZero(row => row.category.order))
					.sort(this.compareNonZero(row => row.tournament.order))
					.map(row => row.tournament);
				// non sono impazzito, riordina per: sport, categoria, torneo (stablesort)
				this.setState({ topLeagues: sortedTopleagues, currentTournamentId: sortedTopleagues[0] && sortedTopleagues[0].id });
			}
		});
	}

	setTournament(tournament) {
		this.setState({ currentTournamentId: tournament.id })
	}

	isCurrent(tournament) {
		return this.state.currentTournamentId == tournament.id;
	}

	render() {
		if (this.state.topLeagues.length == 0)
			return null;

		return <div>
			<D.CardHeaderRow>
				<D.ThreeDots />
				<D.TournamentSportName><Trans>Top Leagues</Trans></D.TournamentSportName>
			</D.CardHeaderRow>
			<div class="grid grid-cols-2">
				{this.state.topLeagues.map(tournament => PFeed.getWithParents(tournament.id)).map(({ tournament, category }) => (
					<div
						class={"flex items-center text-slate-950 dark:text-white gap-2 border border-slate-300 dark:border-slate-600 px-2 py-1 text-sm " + (this.isCurrent(tournament) ? 'bg-slate-100 dark:bg-slate-600' : 'bg-slate-200 dark:bg-slate-800')}
						onClick={e => this.setTournament(tournament)}
					>
						<P.TournamentIcon tournament={tournament} class={"h-5 w-5 league-" + category.name.toLowerCase().replace(/ /g, '') + tournament.name.toLowerCase().replace(/ /g, '')} />
						<span class="min-w-0 flex-1 truncate">{tournament.name}</span>
					</div>
				))}
			</div>
			{this.state.currentTournamentId && <WrappedPrematchTournamentPage key={this.state.currentTournamentId} tournamentId={this.state.currentTournamentId}>
				{({ tournament }) => <TournamentCard tournamentCard={tournament} />}
			</WrappedPrematchTournamentPage>}
		</div>
	}
}


export class WithPrematch extends Component {
	componentWillMount() {
		PFeed.getMenu(() => this.setState({}))
	}
	bestSport(menu) {
		return Object.values(menu).sort((a, b) => a.order - b.order)[0]
	}
	render({ children }) {
		if (!PFeed.menu)
			return;
		return children;
	}
}

export class MobileLastMinute extends PrematchLastminuteContent {
	render() {
		if (!this.state.tournament) return null;
		return <div>
			<D.CardHeaderRow>
				<D.ThreeDots />
				<D.TournamentSportName><Trans>Last Minute</Trans></D.TournamentSportName>
			</D.CardHeaderRow>
			<TournamentCard tournamentCard={this.state.tournament} />
		</div>
	}
}
export class MobileMostPlayed extends PrematchLastminuteContent {
	downloadSport(sportId) {
		Page.openMostPlayedEventsMerged(sportId, {}, (id, data) => {
			this.setState({ tournament: data });
		});
	}
	render() {
		if (!this.state.tournament) return null;
		return <div>
			<D.CardHeaderRow>
				<D.ThreeDots />
				<D.TournamentSportName><Trans>Top Matches</Trans></D.TournamentSportName>
			</D.CardHeaderRow>
			<TournamentCard tournamentCard={this.state.tournament} />
		</div>
	}
}
export class MobileLiveEvents extends PrematchLiveEvents {
	getCurrentSport() {
		return LFeed.menu["/sport/1"]
	}
	getCategories() {
		return Object.values(this.getCurrentSport().sub).sort((a, b) => a.name.localeCompare(b.name));
	}
	render() {
		return <div>
			<D.CardHeaderRow>
				<D.ThreeDots />
				<D.TournamentSportName><Trans>Live</Trans></D.TournamentSportName>
			</D.CardHeaderRow>
			{this.getCurrentSport() && this.getCategories().map(tournament =>
				<Tournament key={tournament.id} tournament={tournament} />
			)}
		</div>
	}
}
